import React from 'react';
import PropTypes from 'prop-types';

import {
  Container,
  MainContainer,
  Logo,
  Title,
  Subtitle,
  BlueStrip,
  Link,
} from '../styles';

const ScreenerSessionOutdated = (props) => {
  const {
    location: {
      state = {},
    },
  } = props;

  const audienceTypePathName = (state.user.tester && !state.user.guest) ? 'recruit-participants' : 'guest-tester';
  const studyURL = `/${audienceTypePathName}?token=${state.recruitParticipantToken}`;

  return (
    <Container>
      <Logo src="/images/playbook-logo.png" alt="Playbook" />

      <BlueStrip />

      <MainContainer>
        <Title>Error</Title>

        <Subtitle>
          {state.errors || 'Your screener is outdated, please use the link below to restart your study.'}
        </Subtitle>

        <Link href={studyURL}>
          Click here to access this study updated
        </Link>
      </MainContainer>
    </Container>
  );
};

ScreenerSessionOutdated.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      errors: PropTypes.string,
      recruitParticipantsToken: PropTypes.string,
      user: PropTypes.shape({
        tester: PropTypes.bool,
        guest: PropTypes.bool,
      }),
    }),
  }).isRequired,
};

export default ScreenerSessionOutdated;
